class ModularConfiguratorPageQuery {
  public constructor(
    public readonly layoutCode: string,
    public readonly code: string,
    public readonly debugPerformance?: boolean,
    public readonly debugMaterial?: string,
  ) {}
}

export default ModularConfiguratorPageQuery;
